<p-inputnumber
  [id]="name"
  suffix=" %"
  [min]="0"
  [max]="100"
  [placeholder]="placeholder"
  [fluid]="fluid"
  [(ngModel)]="value"
  (ngModelChange)="updateFormControl($event)"
/>
